// Custom Hero Fade-in Animation
(function () {
  function reveal(hero) {
    if (hero) hero.classList.add('fade-in');
  }

  function initHero(hero) {
    if (!hero || hero.dataset.heroFadeInit) return;
    hero.dataset.heroFadeInit = 'true';

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            obs.unobserve(entry.target); // only trigger once
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });
      observer.observe(hero);
    } else {
      reveal(hero);  
    }

    setTimeout(function () {
      if (hero.getBoundingClientRect().top < window.innerHeight) reveal(hero);
    }, 100);
  }

  function initAll(root) {
    (root || document).querySelectorAll('.c-hero-section').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    reveal(event.target.querySelector('.c-hero-section'));
  });
})();
